var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.40537 20.2034C3.77565 20.2034 3.23905 19.9817 2.79557 19.5382C2.3521 19.0947 2.13037 18.5581 2.13037 17.9284V6.0719C2.13037 5.44218 2.35212 4.90558 2.79562 4.4621C3.23909 4.01862 3.77568 3.79688 4.4054 3.79688H20.2619C20.8916 3.79688 21.4282 4.01862 21.8717 4.4621C22.3152 4.90558 22.5369 5.44218 22.5369 6.0719V17.9284C22.5369 18.5581 22.3152 19.0947 21.8717 19.5382C21.4282 19.9817 20.8916 20.2034 20.2619 20.2034H4.40537ZM12.3336 13.2572L4.40537 8.25723V17.9284H20.2619V8.25723L12.3336 13.2572ZM12.3336 11.0719L20.2619 6.0719H4.40537L12.3336 11.0719ZM4.40537 8.25723V6.0719V17.9284V8.25723Z",
    fill: "#184BC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/EmailIcon.7fb9bbbf945a934f70dfe7464b6aa4c5.svg";
export { ForwardRef as ReactComponent };